<template>
    <div class="other-message-body">
        <div class="thum-container">
            <img class="participant-thumb" :src="other.profilePic"
                 style="width: 30px; height: 30px; border-radius: 50%;">
        </div>
        <div class="chat-bubble">
            <div class="typing">
                <div class="dot"></div>
                <div class="dot"></div>
                <div class="dot"></div>
            </div>
    </div>
    </div>
</template>
<script>
  export default {
        props:{
            other: {
                type: Object,
                required: true
            },
        }
  }
</script>